import { EMAIL_UPDATE } from '../actions/email.js'

export default function email(state, action) {
	switch (action.type) {
		case EMAIL_UPDATE: {
			return { ...state, ...action.payload }
		}

		default: {
			return state
		}
	}
}
